/* The x-data root every page puts on <html>: theme + the header menus.
   Registered as Alpine.data("data") by boot/base.js. */
export default function data() {
  /* Must agree with the pre-paint script in base.html: if these two disagree
     about a visitor with no stored preference, the page paints one theme and
     then switches to the other. */
  function getThemeFromLocalStorage() {
    // a theme the user has actually chosen always wins. Compared against null
    // rather than tested for truthiness: the stored value is the STRING
    // "false" for light, which is itself truthy.
    const stored = window.localStorage.getItem('dark')
    if (stored !== null) {
      try {
        return JSON.parse(stored)
      } catch (e) {
        // unparseable value from an older build: fall through to the default
      }
    }

    // New visitor: dark, regardless of the OS prefers-color-scheme.
    return true
  }

  function setThemeToLocalStorage(value) {
    window.localStorage.setItem('dark', value)
  }

  return {
    dark: getThemeFromLocalStorage(),
    toggleTheme() {
      this.dark = !this.dark
      setThemeToLocalStorage(this.dark)
    },
    isSideMenuOpen: false,
    toggleSideMenu() {
      this.isSideMenuOpen = !this.isSideMenuOpen
    },
    closeSideMenu() {
      this.isSideMenuOpen = false
    },
    isNotificationsMenuOpen: false,
    toggleNotificationsMenu() {
      this.isNotificationsMenuOpen = !this.isNotificationsMenuOpen
    },
    closeNotificationsMenu() {
      this.isNotificationsMenuOpen = false
    },
    isProfileMenuOpen: false,
    toggleProfileMenu() {
      this.isProfileMenuOpen = !this.isProfileMenuOpen
    },
    closeProfileMenu() {
      this.isProfileMenuOpen = false
    },
    isPagesMenuOpen: false,
    togglePagesMenu() {
      this.isPagesMenuOpen = !this.isPagesMenuOpen
    },
  }
}
